module.exports = __webpack_public_path__ + "laserove-beleni-zubu_5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/special/laserove-beleni-zubu_5.jpg
// module id = 913
// module chunks = 0